import _getVideoUrl from '@wix/communities-blog-universal/dist/src/utils/media/video';
export const getVideoUrl = ({ pathname, videoHost }) => _getVideoUrl(videoHost)(pathname);
//# sourceMappingURL=video-utils.js.map